import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  CustomResultOfGetOtpByIdDto,
  GetEnumValuesDto,
  GetOtpsWithPaginationDto,
  OtpStatus,
  PaginatedListOfGetOtpsWithPaginationDto,
} from '../../../core/api/models';
import { OtpsService } from '../../../core/api/services/otps.service';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { ChangeOtpStatusFormComponent } from './change-otp-status-form/change-otp-status-form.component';
import { OtpFormComponent } from './otp-form/otp-form.component';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  imports: [BaseIndexModule, OtpFormComponent],
})
export class OtpComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties
  pageName = PageNames.otp;

  /* binding service endpoints */
  protected currentService = inject(OtpsService);
  paginationApiMethodName: string =
    this.currentService.otpsGetOtpsWithPagination.name;
  createGetApiMethodName: string = this.currentService.otpsCreateGet.name;
  auditApiMethodName: string = this.currentService.otpsGetOtpAudits.name;
  /* binding service endpoints */

  modelWithPagination$: Observable<PaginatedListOfGetOtpsWithPaginationDto>;
  items$: Observable<Array<GetOtpsWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetOtpsWithPaginationDto> = {};
  OtpStatusEnumValues: GetEnumValuesDto[] = [];

  get OtpStatusType() {
    return OtpStatus;
  }

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEnumsValues() {
    this.getEnumValuesApi('OtpStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.OtpStatusEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'id',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
      },
      {
        title: this.localizer.userName,
        name: 'userName',
        hasSearch: true,
      },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: this.localizer.title,
        name: 'title',
        hasSearch: true,
      },
      {
        title: this.localizer.status,
        name: 'status',
        hasSearch: true,
        type: 'enum',
        enumName: 'OtpStatus',
      },
      {
        title: `${this.tableVocabs}priority`,
        name: 'priority',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}smsText`,
        name: 'smsText',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}lastModified`,
        name: 'lastModified',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .otpsUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  getChangeStatusApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .otpsUpdateStatusGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(
        (response: CustomResultOfGetOtpByIdDto) => {
          if (response) {
            this.onShowChangeStatus(
              response.data?.id,
              response.data?.status,
              response.data?.priority
            );
          }
        },
        (error) => ConsoleService.error('error', error),
        () => (this.pageConfig.loading = false)
      );
  }
  //#endregion

  onShowChangeStatus(id, status, priority) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}changeStatusTitle`,
        isEdit: true,
        pageVocab: 'pages.otp.form.',
        model: {
          id: id,
          status: status,
          priority: priority,
        },
      };

      const modalResult = this.dialogService.openModal({
        component: ChangeOtpStatusFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }
}
